import type {
  TTermsDocumentVersion,
  TTermsDocumentVersionListItem,
  TTermsDocument,
  TTermsDocumentFilters,
  TTermsDocumentVersionCreate,
  TTermsDocumentVersionUpdate,
  TTermsDocumentVersionAcceptResponse,
  TTermsDocumentVersionHistoryEntry,
} from "./types";
import {
  createPathParamCRUD,
  getPathParam,
  createPathParam,
  type NoPathParams,
} from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";

export * from "./types";

type TVersionPathParams = { doc_pk: string };
export type TVersionItemPathParams = TVersionPathParams & { id: number };

const TERMS_BASE = "/api/v1/terms";
const TERMS_VERSIONS_BASE = `${TERMS_BASE}/{doc_pk}/versions`;

export default createService(TERMS_BASE, {
  ...createPathParamCRUD<
    TTermsDocument,
    NoPathParams,
    TTermsDocumentFilters,
    Pick<TTermsDocument, "title">,
    Pick<TTermsDocument, "title">
  >(TERMS_BASE),

  versions: createService(TERMS_VERSIONS_BASE, {
    ...createPathParamCRUD<
      TTermsDocumentVersionListItem,
      TVersionPathParams,
      DefaultPaginatedFilters,
      TTermsDocumentVersionCreate,
      TTermsDocumentVersionUpdate
    >(TERMS_VERSIONS_BASE),

    getVersion: getPathParam<TTermsDocumentVersion, TVersionItemPathParams>(
      `${TERMS_VERSIONS_BASE}/{id}`
    ),

    accept: createPathParam<TTermsDocumentVersionAcceptResponse, TVersionItemPathParams>(
      `${TERMS_VERSIONS_BASE}/{id}/accept`
    ),

    history: getPathParam<TTermsDocumentVersionHistoryEntry[], TVersionItemPathParams>(
      `${TERMS_VERSIONS_BASE}/{id}/history`
    ),
  }),
});
